import React, { useState, useEffect } from 'react';

import Dialog, {
  DialogActions,
  DialogTitle,
  DialogContent,
  DialogContentText
} from 'material-ui/Dialog';

import Button from 'material-ui/Button';

const dialogContainer = {
    display: 'flex',
    alignItems: 'center',
    borderRadius: 7,
    boxShadow:
        '0px 11px 15px -7px rgba(0, 0, 0, 0.2), 0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 9px 46px 8px rgba(0, 0, 0, 0.12)',
    minwidth: '30vw',
    overflow: 'visible',
};

const dialogTextStyle = {
    textAlign: 'center',
};

const primaryDialogTextStyle = {
    textAlign: 'center',
    paddingBottom: '0.5em',
};

const dialogeTimerText = {
    fontSize: '1.5em',
    textAlign: 'center',
};

const RenderConfirmationTimeoutDialog = (props) => {
    const [milliSeconds, setMilliSeconds] = useState(props.timeoutInterval);
    const [seconds, setSeconds] = useState(1);

    useEffect(() => {
        let timeoutTimer;

        if (milliSeconds > 0 && props.open) {
            timeoutTimer = setTimeout(() => {
                setMilliSeconds(milliSeconds - 1000);
                setSeconds(seconds + 1);
            }, 1000);
        } else if (props.open) {
            props.handleIdleTimeout();
        }

        return () => clearTimeout(timeoutTimer);
    });

    return (
        <Dialog
        open={props.open}
        aria-labelledby="timeout warning dialogue"
        PaperProps={{
          style: { ...dialogContainer }
        }}
        >
            <DialogContent>
                <DialogTitle className="dialogHeaderStyle" style={dialogTextStyle}>
                    Success!
                </DialogTitle>
                <DialogContentText style={primaryDialogTextStyle}>
                    Your changes have been saved.
                </DialogContentText>
                <DialogContentText style={dialogTextStyle}>
                    If you wish to remain on this page, click ‘Return to {props.page}’ otherwise you will be redirected to the Search screen in {((props.timeoutInterval % 60000) / 1000).toFixed(0)} seconds.
                </DialogContentText>
                <DialogTitle style={dialogeTimerText}>
                    {seconds}
                </DialogTitle>
            </DialogContent>

            <DialogActions className="time-out-btn-container">
                <Button
                    className="primary-solid-btn"
                    onClick={props.stayInAction}
                >
                Return to {props.page}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default RenderConfirmationTimeoutDialog;


// WEBPACK FOOTER //
// ./src/helpers/RenderConfirmationTimeoutDialog.js